import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import CSSModules from 'react-css-modules'
import Isvg from 'react-inlinesvg'

import { localize } from 'helpers/translator'
import OverlayNotification from 'components/overlay_notification/overlay_notification'

import styles from './countdown_notification_wait.scss'

import stopwatchSvg from 'assets/components/notification_box/stopwatch-icon.svg'

class WaitNotificationOverlay extends PureComponent {

	render() {
		const stopwatch = <Isvg src={stopwatchSvg} cacheGetRequests={true} />
		const title = <span>{localize('activity_timer_timeFor')}<br />{this.props.activityName}</span>
		const minutes = this.props.remainingMinutes > 0 ?
			` ${this.props.remainingMinutes} ${localize('activity_timer_min')}` :
			''
		const seconds = this.props.remainingSeconds > 0 ?
			` ${this.props.remainingSeconds} ${localize('activity_timer_sec')}` :
			''
		const text = (
			<span>
				{localize('activity_timer_youWillHave')}<span className={styles['text-time']}>{minutes}{seconds}</span>.<br />
				{localize('activity_timer_readySet')}
			</span>
		)

		return (
			<OverlayNotification color='light-blue' icon={stopwatch} title={title} text={text} />
		)
	}

}

WaitNotificationOverlay.propTypes = {
	remainingMinutes: PropTypes.number,
	remainingSeconds: PropTypes.number,
	activityName: PropTypes.string,
}

WaitNotificationOverlay.defaultProps = {
	activityName: localize('matchingPairs_timeForMatchingPairs2'),
}

export default CSSModules(WaitNotificationOverlay, styles, {allowMultiple: true})
